import React from "react";
import styled from "styled-components";
import posed from "react-pose";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Emoji from "../Emoji/Emoji";

const Sidebar = styled(
  posed.div({
    open: {
      x: "0%",
      delayChildren: 300,
      staggerChildren: 75
    },
    closed: { x: "-100%", delay: 300 }
  })
)`
  width: 100vw;
  @media (min-width: 575px) {
    width: 300px;
  }
  background: rgba(255, 255, 255, 0.9);
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0;
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 555;
`;

const Item = posed.div({
  open: { y: 0, opacity: 1 },
  closed: { y: 20, opacity: 0 }
});

const LStyle = `
display: flex;
justify-content: flex-start;
align-items: center;

margin: 20px 0px;
text-decoration: none;
`;

const StyledLink = styled(Link)`
  ${LStyle};
  font-size: ${props => (props.isSmall ? "15px" : "36px")};
`;
const StyledAnchor = styled.a`
  ${LStyle};
  font-size: ${props => (props.isSmall ? "15px" : "36px")};
`;

const MenuEmoji = styled(Emoji)`
  margin-right: 20px;
`;

const LogoImg = styled.img`
  max-height: 16px;
  margin-left: 10px;
`;

const Menu = ({ visible }) => (
  <Sidebar pose={visible ? "open" : "closed"}>
    <div>
      <Item>
        <StyledLink to="/">
          <MenuEmoji>:house:</MenuEmoji> Home
        </StyledLink>
      </Item>

      <Item>
        <StyledLink to="/faq">
          <MenuEmoji>:interrobang:</MenuEmoji>
          FAQ
        </StyledLink>
      </Item>

      <Item>
        <StyledAnchor target="_blank" href="https://mnm.be">
          <MenuEmoji>:mega:</MenuEmoji> Meer verkiezingen
        </StyledAnchor>
      </Item>
    </div>
    <div>
      <Item>
        <StyledAnchor
          href="#cookie"
          isSmall={true}
          onClick={e => {
            e.preventDefault();
            window.VRT &&
              window.VRT.cookieConsent &&
              window.VRT.cookieConsent.showConsent();
          }}
        >
          <MenuEmoji>:cookie:</MenuEmoji>
          Cookie instellingen{" "}
        </StyledAnchor>
      </Item>

      <Item>
        <StyledAnchor
          target="_blank"
          isSmall={true}
          href="https://www.vrt.be/vrtnws/"
        >
          <MenuEmoji>:heart:</MenuEmoji> In samenwerking met{" "}
          <LogoImg
            src={require("../../assets/images/vrtnws.svg")}
            alt="VRT NWS"
          />
        </StyledAnchor>
      </Item>
    </div>
  </Sidebar>
);

const mapStateToProps = state => {
  return {
    visible: state.menu.visible
  };
};

export default connect(mapStateToProps)(Menu);



// WEBPACK FOOTER //
// ./src/components/Menu/index.js